import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function () { return ({
    root: {
        height: function (_a) {
            var openDrawer = _a.openDrawer;
            return (openDrawer ? 70 : 76);
        },
        minHeight: function (_a) {
            var openDrawer = _a.openDrawer;
            return (openDrawer ? 70 : 76);
        },
        color: "#ffff",
        transition: "width ease 0.3s !important",
    },
    mainIsOpen: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
        height: "100%",
        paddingLeft: "16.8px",
        paddingRight: "16.8px",
        transition: "width ease 0.3s !important",
        flexDirection: "column",
        overflow: "hidden",
    },
    mainIsClose: {
        display: "flex",
        paddingLeft: "16.8px",
        paddingRight: "16.8px",
        animation: "cssAnimation 0s 6s forwards",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.4,
        overflow: "hidden",
        "& button": {
            width: 33,
            height: 33,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "transparent",
            border: "unset",
            "&:hover": {
                cursor: "pointer",
                backgroundColor: "rgba(255, 255, 255, .10)",
                borderRadius: "4px",
                transition: "opacity 0.5s ease-in-out",
            },
        },
    },
    FAQTitle: {
        transition: "opacity 0.5s ease-in-out",
        backgroundColor: "transparent",
        border: "unset",
        color: "white",
        padding: 0,
        "&:hover": {
            opacity: "0.8",
            cursor: "pointer",
        },
    },
    systemLogsTitle: {
        transition: "opacity 0.5s ease-in-out",
        backgroundColor: "transparent",
        border: "unset",
        color: "white",
        padding: 0,
        marginRight: "6px",
        "&:hover": {
            opacity: "0.8",
            cursor: "pointer",
        },
    },
    versionName: {
        display: "flex",
        alignItems: "center",
        transition: "opacity 0.5s ease-in-out",
        backgroundColor: "transparent",
        border: "unset",
        color: "white",
        padding: 0,
        "& p:nth-child(1)": {
            fontWeight: 600,
            fontSize: "14px",
            lineHeight: "19.1px",
            fontFamily: "Nunito Sans, Samim, sans-serif",
        },
        "& p:nth-child(2)": {
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: "12px",
            lineHeight: "16.37px",
            color: "#0D346C",
            backgroundColor: "white",
            borderRadius: "20px",
            padding: "0px 8px",
            marginLeft: "6px",
            minHeight: 20,
            fontFamily: "Nunito Sans, Samim, sans-serif",
        },
        "&:hover": {
            opacity: "0.8",
            cursor: "pointer",
        },
    },
    divider: {
        height: 18,
        backgroundColor: "rgba(255, 255, 255, 0.3)",
    },
    systemLogsCount: {
        fontWeight: 700,
        fontSize: "12px",
        lineHeight: "16.37px",
        borderRadius: "20px",
        backgroundColor: "#192B46",
        padding: "2px 6px",
        fontFamily: "Nunito Sans, Samim, sans-serif",
    },
}); });
